import React from 'react'
import Applink from '../app-link/'
import {Link} from 'react-router-dom'
import {Modal} from 'antd';
import "./index.css"
import {syllabusData, Company, partnerData} from './footerData';

class Footer extends React.Component {
    state = {
        aboutus: false,
        ourteam: false,
        joinourteam: false,
        faq: false,
        iso: false,
        tnc: false,
        partner: false,
    };

    aboutus(aboutus) {
        this.setState({aboutus});
    }

    ourteam(ourteam) {
        this.setState({ourteam});
    }

    joinourteam(joinourteam) {
        this.setState({joinourteam});
    }

    faq(faq) {
        this.setState({faq});
    }

    iso(iso) {
        this.setState({iso});
    }

    tnc(tnc) {
        this.setState({tnc});
    }

    partner(partner) {
        this.setState({partner});
    }

    resetModal() {
        this.setState({
            aboutus: false,
            ourteam: false,
            joinourteam: false,
            faq: false,
            iso: false,
            tnc: false,
            partner: false,
        });
    }

    render() {
        return (
            <div id="footer">
                <div className="cd-container">
                    <div className="row pt-5 mb-5 footer-data">
                        <div className="col-lg-4 col-md-12">
                            <h5>Who We are</h5>
                            <p>Career Dose aims to nurture the brains of young minds. We want to create a difference
                                when it comes. In the present era, there are so many options available for the
                                young generation, and as they say, choices often lead to confusions. We at Career Dose
                                put all our efforts to make our young minds confusion-free with clarity on the
                                subject and career. We aim to help in all-around development of minds before they hit
                                the job battlefield.</p>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <h5>Syllabus</h5>
                            <ul className="list-unstyled">
                                {syllabusData.map((item, index) => (
                                    <li key={index}>
                                        <Link to={`/${item.link}`}>
                                            <span>Class {item.class}</span>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <h5>About French</h5>
                            <p>Learning French with CAREER DOSE is an interactive adventure. All classes are based on a
                                student-centered curriculum that accommodates each student’s interests and
                                passions, giving learning the freedom to flourish.</p>
                            <Link to="/language_class/french">
                                <button className="btn btn-sm cd-btn-primary text-uppercase m-0 cd-pill letter-space"><i
                                    className="fas fa-eye mr-2"/>View More<i
                                    className="fas fa-arrow-right ml-2"/></button>
                            </Link>
                        </div>
                    </div>
                    <div className="row pb-5 footer-data">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <h5>Company</h5>
                            <ul className="list-unstyled">
                                <li>
                                    <span onClick={() => this.aboutus(true)}>About Us</span>
                                </li>
                                <Modal
                                    title="About Us"
                                    centered
                                    visible={this.state.aboutus}
                                    onOk={() => this.aboutus(false)}
                                    onCancel={() => this.aboutus(false)}
                                    footer={null}
                                    mask
                                    maskClosable
                                >
                                    <h6 className="cd-note cd-note-warning m-0">Who We Are?</h6>
                                    <p>Career Dose aims to nurture the brains of young minds. We want to create a
                                        difference. In the present era, there are so many options available for the
                                        young
                                        generation, and as they say, choices often lead to confusions. We at Career Dose
                                        put all our efforts to make those young minds confusion-free. We aim to help in
                                        all-around development of minds before they hit the work battlefield.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Our Principle</h6>
                                    <p>Our vision is to take up the Responsibility to associate with students so that
                                        they can develop the leadership skills which can increase the quality of their
                                        life.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Our Mission</h6>
                                    <p>Our idea of developing the generations starts with our mission, that is enduring.
                                        It states our purpose as a responsible company and serves as a benchmark
                                        against which we weigh our commitments and actions.
                                        <ul>
                                            <li>To inspire the generations.</li>
                                            <li>To pump options for excellent career prospects.</li>
                                            <li>To conceive value and mark a difference.</li>
                                        </ul>
                                        Our experts understand how important their job is. We aim to provide the proper
                                        guidance so that students get to realize their potential. We focus on creating a
                                        platform where students can feel free, and we help them manage their complete
                                        academic portfolio. We drive the student’s Career Expectations realistically to
                                        the right Career Path.<br/><br/>
                                        We understand that no two students fit into the same profile. Our team is well
                                        aware of every ins and outs of the situation. We access every profile with
                                        proper
                                        care as we know that helping a student out to choose his/her career is a
                                        critical task as we will be providing a base on which the whole building of the
                                        profession will be constructed.
                                    </p>
                                </Modal>
                                <li>
                                    <span onClick={() => this.joinourteam(true)}>Careers</span>
                                </li>
                                <Modal
                                    title="Join Our Team"
                                    centered
                                    visible={this.state.joinourteam}
                                    onOk={() => this.joinourteam(false)}
                                    onCancel={() => this.joinourteam(false)}
                                    mask
                                    maskClosable
                                    footer={[
                                        <Link to="/hr_careerdose">
                                            <button
                                                className="btn btn-sm cd-btn-danger text-uppercase m-0 cd-pill letter-space">Join
                                                Now<i className="fas fa-arrow-right ml-2"/></button>
                                        </Link>
                                    ]}
                                >
                                    <p>Career Dose aims to nurture the brains of young minds. We at Career Dose put all
                                        our efforts to make those young minds confusion-free. We aim to help in
                                        all-around development of minds before they hit the job battlefield. Our
                                        ideology is to guide children so that they become self-sufficient to manage
                                        their life
                                        by knowing their hidden potential.</p>
                                    <p>To be a great place to work, we need great people to work with us. Everything we
                                        do, every day, in more ways than one, helps to make a unique contribution to
                                        Student’s life. We want to make a difference so that problems faced by students
                                        fly away, and for that purpose, we strive to offer high-quality service as
                                        professionals in all situations. We believe in our core values; we continue to
                                        identify talented people who share these principles. For us, our people are
                                        especially important.</p>
                                    <p>If you’re creative, hard-working, and are looking to make a difference, you might
                                        want to consider working with us. We’re searching for the best and brightest,
                                        the most committed. At the end of the day, it’s all about good results which can
                                        make a difference.</p>
                                    <p>We offer flexible shifts and benefits and some exciting company’s perks.</p>
                                </Modal>
                                <li>
                                    <span onClick={() => this.faq(true)}>FAQs</span>
                                </li>
                                <Modal
                                    title="Frequently Asked Questions"
                                    style={{top: 20}}
                                    visible={this.state.faq}
                                    onOk={() => this.faq(false)}
                                    onCancel={() => this.faq(false)}
                                    mask
                                    maskClosable
                                    footer={null}
                                >
                                    <h6 className="cd-note cd-note-warning m-0">What is a Career Assessment?</h6>
                                    <p>An assessment is a series of questions or statements that one answers or responds
                                        to, that are then scored by several experts. The results are provided in a
                                        report that measures or gives feedback on the aptitude, personality, interest,
                                        adjustment, etc. A Career Assessment offers information about careers and helps
                                        one make wise career-related decisions. It helps to know more about one’s hidden
                                        potential and provides proper guidance to improve the quality of life.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Why is Career Counseling Important?</h6>
                                    <p>It helps to create an equilibrium between the student’s desires and practicality.
                                        Due to the availability of so many choices, many times, students are confused,
                                        and their energy is channelized to many fields, which often leads to having
                                        career desires in many areas. Thus, counseling helps students to channelize
                                        their
                                        power to the ground where it is appropriate for them to grow. It allows students
                                        to estimate their strengths and weaknesses so they may focus on what is most
                                        practical for them. When a candidate’s profile is evaluated by the counselor, it
                                        provides him/her a clear vision.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Why choose Career Dose for Career
                                        Counseling?</h6>
                                    <p>We aim to brighten the career of the students of this country. Our counselors are
                                        always ready to help and share their views. We aim to provide every single help
                                        to not only students but to parents also so there can be a proper balance of
                                        relationship and the child can grow. Our counselors follow specific steps
                                        whenever
                                        they’re counseling students.
                                        <ol>
                                            <li>We understand every student.</li>
                                            <li>We make proper portfolios.</li>
                                            <li>We don’t force anything; we only provide support.</li>
                                            <li>We are full of acceptance.</li>
                                        </ol>
                                    </p>
                                    <h6 className="cd-note cd-note-warning m-0">Why are Career Dose Tutorials
                                        useful?</h6>
                                    <ol>
                                        <li>We try to personalize the learning environment.</li>
                                        <li>We are passionate, and we make sure that students remain eager to learn.
                                        </li>
                                        <li>We focus on student participation.</li>
                                        <li>We always explore new ways to make our tutorials useful.</li>
                                        <li>We engage our students efficiently.</li>
                                        <li>We know every student is different, so we try to keep everything easy to
                                            understand.
                                        </li>
                                        <li>We focus on the quality of education we provide.</li>
                                        <li>We try to develop logical thinking in students.</li>
                                    </ol>
                                    <h6 className="cd-note cd-note-warning m-0">Why should Students learn French?</h6>
                                    <p>The importance of the french language is well known. French has around 78.6
                                        million native speakers, and it has more than 274 million speakers around the
                                        world
                                        (source-Wikipedia). French is the official language of 29 countries. It derives
                                        its roots from the Indo-European family of languages. In March 2014, in a study
                                        published by Forbes, the investment bank Naxtixis said French could become
                                        World’s Most Spoken Language by 2050.</p>
                                    <h6 className="cd-note cd-note-warning m-0">What tutorials do Career Dose
                                        Provide?</h6>
                                    <p>Career Dose offers practical tutorials on:
                                        <ol>
                                            <li>French Learning</li>
                                            <li>Maths</li>
                                            <li>Science</li>
                                        </ol>
                                    </p>
                                </Modal>
                                <li>
                                    <Link to="/contact_us">
                                        <span>Contact us</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <h5>Our Branches</h5>
                            <ul className="list-unstyled">
                                {partnerData.map((item, index) => (
                                    <li key={index}>
                                        <Link to={item.link}>
                                            <span>{item.class}</span>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <h5>What We Do</h5>
                            <ul className="list-unstyled">
                                <li>
                                    <span onClick={() => this.iso(true)}>ISO Certification</span>
                                </li>
                                <Modal
                                    title="ISO Certification"
                                    centered
                                    visible={this.state.iso}
                                    onOk={() => this.iso(false)}
                                    onCancel={() => this.iso(false)}
                                    mask
                                    maskClosable
                                    footer={null}
                                >
                                    <p>For more than twenty years, ISO 9001 has been recognized as the ideal way for an
                                        organization to prove they take delivering a quality service seriously. The
                                        standard was released in 1987, being constantly reviewed and improved ever
                                        since.</p>
                                    <p>We are proud to say that Career Dose is ISO 9001:2015 certified in the field of
                                        IT services and Education.</p>
                                    <p>We have proved ourselves over time. We focus to improve the quality of our
                                        services everyday. Our teams are committed to deliver the best.</p>
                                </Modal>
                                <li>
                                    <span onClick={() => this.tnc(true)}>Terms & Conditions</span>
                                </li>
                                <Modal
                                    title="Terms & Condition"
                                    style={{top: 20}}
                                    visible={this.state.tnc}
                                    onOk={() => this.tnc(false)}
                                    onCancel={() => this.tnc(false)}
                                    mask
                                    maskClosable
                                    footer={null}
                                >
                                    <h6 className="cd-note cd-note-warning m-0">General Terms of Use</h6>
                                    <p>Career Dose operates each website ("Site") that links to following Terms of Use
                                        to provide online access to information about our products, services, and
                                        opportunities.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Permitted Use of the Website</h6>
                                    <p>The user may use the site, and the images, writings, projects and/or other work
                                        present on the site. The user may solely access the content for the
                                        non-commercial/personal use and strictly in compliance with the terms of
                                        use.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Information or Material the User Post or
                                        Provide</h6>
                                    <p>The user is liable to the information provided by him/her. Any false/fictitious
                                        information provided by the user is against the terms and violates the law. The
                                        user is liable for the information provided. The posted Materials must not
                                        contain any threatening, harassing, libelous, false, defamatory, offensive,
                                        obscene,
                                        or pornographic, material, or other material that would violate any other
                                        applicable law or regulation</p>
                                    <h6 className="cd-note cd-note-warning m-0">Copyright and Trademark</h6>
                                    <p>This website is based upon proprietary of Career Dose, and the content/work
                                        solely belongs to the company. The company owns and retains the copyright of all
                                        the
                                        content. The website is protected by intellectual property rights, including the
                                        trademark and the copyright laws.<br/><br/>
                                        The content must not be modified, published, uploaded, posted, distributed, and
                                        copied in any form. You agree not to publish, modify, upload, transmit,
                                        broadcast, and create the copy of the content on the website.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Link to the Third-Party Websites</h6>
                                    <p>Any links present on the website to the third-party websites are provided by the
                                        company for the purpose of the user’s convenience. Once the user clicks on the
                                        link, the user has left the website after that. Such links do not imply any
                                        promotion or endorsement of any other site. We are not liable for any content
                                        present on the Third-Party Websites.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Advertisers</h6>
                                    <p>There may be some advertisements present on the website. The advertiser is liable
                                        for their material submitted to the site. Career Dose is not responsible for
                                        any kind of illegality of the product/advertisement.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Refund Policy</h6>
                                    <p>Career Dose has a 7 calendar day refund window from the starting date of service
                                        delivery for all our products and services, post which the company is not
                                        liable to provide any refunds under any circumstances. If a customer does not
                                        like our services, they can ask for a refund within the 15 day period. Send an
                                        email to refunds@careerdose.com for the same. If a customer is entitled
                                        to a
                                        refund, we will refund the purchase price, using the original method of
                                        payment.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Comments Removal</h6>
                                    <p>The website has all rights to remove any kind of the obscene/ vulgar comments by
                                        any of the user from the website.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Indemnity</h6>
                                    <p>The user hereby indemnifies the company and undertake to keep the Company
                                        indemnified against any damages, costs, liabilities, and losses incurred due
                                        to/claim
                                        of any breach by the user which are against the provisions of terms of use.</p>
                                </Modal>
                                <li>
                                    <Link to="/privacy_policy">
                                        <span>Privacy Policy</span>
                                    </Link>
                                </li>
                                <li>
                                    <span onClick={() => this.partner(true)}>Partner with us</span>
                                </li>
                                <Modal
                                    title="Partner With Us"
                                    centered
                                    visible={this.state.partner}
                                    onOk={() => this.partner(false)}
                                    onCancel={() => this.partner(false)}
                                    mask
                                    maskClosable
                                    footer={[
                                        <Link to="/contact_us">
                                            <button
                                                className="btn btn-sm cd-btn-danger text-uppercase m-0 cd-pill letter-space">Register
                                            </button>
                                        </Link>
                                    ]}
                                >
                                    <p>We at Career Dose put all our efforts to make those young minds confusion-free.
                                        We aim to help in all-around development of minds before they hit the job
                                        battlefield. Our ideology is to guide children so that they become
                                        self-sufficient to manage their life by knowing their hidden potential.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Make a difference your way</h6>
                                    <p>Work where you’re inspired to explore your passions, where your talents are
                                        nurtured and cultivated. get the tools you need to keep learning and growing so
                                        you
                                        stay continually ahead of the game while making a difference in the world.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Partner With Us</h6>
                                    <p>You might want to consider working with us. We’re searching for the best and
                                        brightest, the most committed. At the end of the day, it’s all about good
                                        results
                                        which can make a difference.<br/><br/>Career Dose has extremely trained team. We
                                        are committed to make a difference. We know how crucial our job is. We are
                                        dedicated to provide the best results to the students. So, if you are If you’re
                                        creative, hard-working, and are looking to make a difference, Career Dose is a
                                        place where you can grow.<br/><br/>Career Dose brings together members and
                                        partners with aligned goals to create change for young children at speed and at
                                        scale. We do this by drawing on the unique ability of the network to learn,
                                        innovate and share the diverse expertise and knowledge that make our members
                                        effective individually and powerful collectively.<br/><br/>We believe in
                                        long-term relationships that bring value. We believe in win-wins.</p>
                                    <h6 className="cd-note cd-note-warning m-0">Our Mission</h6>
                                    <p>Our idea of developing the generations starts with our mission, that is enduring.
                                        It states our purpose as a responsible company and serves as a benchmark
                                        against which we weigh our commitments and actions.
                                        <ol>
                                            <li>To inspire the generations.</li>
                                            <li>To pump options for excellent career prospects.</li>
                                            <li>To conceive value and mark a difference.</li>
                                        </ol>
                                    </p>
                                </Modal>
                            </ul>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <h5 className="mb-4">Get Social</h5>
                            <div className="mb-4 social-icons">
                                <div className="icon-space cd-bg-primary">
                                    <a href="https://www.facebook.com/careerdose/" target="_blank"
                                       rel="noopener noreferrer"><i className="fab fa-facebook"/></a>
                                </div>
                                <div className="icon-space cd-bg-success">
                                    <a href="https://wa.me/919999155443?text=I'm%20interested" target="_blank"
                                       rel="noopener noreferrer"><i className="fab fa-whatsapp"/></a>
                                </div>
                                <div className="icon-space cd-bg-danger">
                                    <a href="https://www.instagram.com/careerdose_india" target="_blank"
                                       rel="noopener noreferrer"><i className="fab fa-instagram"/></a>
                                </div>
                                <div className="icon-space bg-info">
                                    <a href="https://twitter.com/CareerDose" target="_blank"
                                       rel="noopener noreferrer"><i className="fab fa-twitter"/></a>
                                </div>
                                <div className="icon-space bg-danger">
                                    <a href="https://careerdoseindia.tumblr.com" target="_blank"
                                       rel="noopener noreferrer"><i className="fab fa-tumblr"/></a>
                                </div>
                                <div className="icon-space bg-secondary">
                                    <a href="https://t.me/careerdose_india" target="_blank" rel="noopener noreferrer"><i
                                        className="fab fa-telegram-plane"/></a>
                                </div>
                            </div>
                            <form className="cd-form">
                                <input type="email" name="email" id="email" className="mb-2"
                                       placeholder="Enter Your Email"/>
                                <button type="submit"
                                        className="btn btn-sm cd-btn-primary text-uppercase m-0 cd-pill letter-space"><i
                                    className="fas fa-paperclip mr-2"/>Subscribe
                                </button>
                            </form>
                        </div>
                    </div>
                    <div className="copyright text-center py-3">
                        <Applink/>
                        <p className="m-0 small mt-2">
                            Copyright © 2020 All Rights Reserved&nbsp;|&nbsp;<a href="http://careerdose.com/"
                                                                                target="_blank" className="text-white"
                                                                                rel="noopener noreferrer">Career Dose
                            Pvt. Ltd.</a>
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer